"use client";

import { c as _c } from "react/compiler-runtime";
import { useAIChatInputContext } from "../contexts";
import { HiOutlineX } from "react-icons/hi";
import Button from "@/components/ui/button";
import { cx } from "@/lib/tailwind-utils";
interface AIChatInputCancelButtonProps {
  className?: string;
}
export function AIChatInputCancelButton(t0) {
  const $ = _c(12);
  const {
    className
  } = t0;
  const {
    state,
    actions
  } = useAIChatInputContext();
  if (!state.isStreaming) {
    return null;
  }
  let t1;
  if ($[0] !== actions) {
    t1 = () => actions.cancel();
    $[0] = actions;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = state.isStopping ? "Stopping\u2026" : "Stop generating";
  const t3 = state.isStopping ? "Stopping response" : "Stop generating";
  const t4 = state.isStopping || undefined;
  const t5 = state.isStopping;
  const t6 = state.isStopping;
  let t7;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <HiOutlineX className="size-3.5" />;
    $[2] = t7;
  } else {
    t7 = $[2];
  }
  let t8;
  if ($[3] !== className) {
    t8 = cx("flex h-7 w-7 shrink-0 items-center justify-center rounded-full p-0", className);
    $[3] = className;
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  let t9;
  if ($[5] !== state.isStopping || $[6] !== t1 || $[7] !== t2 || $[8] !== t3 || $[9] !== t4 || $[10] !== t8) {
    t9 = <Button type="button" variant="ghost" onClick={t1} title={t2} aria-label={t3} aria-busy={t4} isLoading={t5} disabled={t6} icon={t7} className={t8} />;
    $[5] = state.isStopping;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  return t9;
}